import { Component } from '@angular/core';
import { HttpLoadingProgressService } from '../../services/http-loading-progress-service/http-loading-progress.service';
import { AsyncPipe } from '@angular/common';
import { MatProgressSpinner } from '@angular/material/progress-spinner';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
  selector: 'app-request-loading-indicator',
  standalone: true,
  imports: [AsyncPipe, MatProgressSpinner, TranslatePipe],
  templateUrl: './request-loading-indicator.component.html',
  styleUrls: ['./request-loading-indicator.component.scss'],
})
export class RequestLoadingIndicatorComponent {
  constructor(public loadingProgressService: HttpLoadingProgressService) {}
}
